import type { ReactElement } from "react";
import { useRef } from "react";
import {
  ExpandingTooltipReturn,
  useAdvancedTooltip,
} from "../hooks/useAdvancedTooltip";
import { ExpandingTooltip } from "./ExpandingTooltip";
import { type Placement } from "react-laag";

export { AdvancedTooltip };

type WithAdvancedTooltipsProps = {
  // FIXME: set to "expanding"
  short?: boolean;
  tooltipText?: ExpandingTooltip;
  overflow?: boolean;
  possiblePlacements?: Placement[];
  children: (data: ExpandingTooltipReturn["triggerProps"]) => ReactElement;
};

const AdvancedTooltip = (props: WithAdvancedTooltipsProps) => {
  const ref = useRef<HTMLElement | null>(null);

  const tooltip = useAdvancedTooltip({
    containerRef: ref,
    noLongText: props.short,
    overflow: props.overflow,
    tooltipText: props.tooltipText,
    placement: props.possiblePlacements
      ? props.possiblePlacements[0]
      : undefined,
    possiblePlacements: props.possiblePlacements ?? ["right-center"],
  });

  return (
    <>
      {props.children({
        ...tooltip.triggerProps,
      })}
      {tooltip.isOpen && tooltip.renderTooltip()}
    </>
  );
};
